module.exports = __webpack_public_path__ + "static/media/4 7 tattoo forearms master chief halo matching minimalist iconic.1280x1707.04ac47fe.webp";